import React, { useEffect } from "react";
import "./App.scss";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import Container from "./Container";
import Alert from "./component/alert";
import { ONBOARD_ERROR_CLOSE } from "./form-store/action-types";
import Spinner from "./component/spinner";

function App() {
  const { onBoardError, obBoardErrorReason } = useSelector(({ form }) => form, shallowEqual);
  const dispatch = useDispatch();
  const loader = useSelector(({ app }) => app.loader, shallowEqual);

  useEffect(() => {
    if (onBoardError) {
      setTimeout(() => {
        dispatch({ type: ONBOARD_ERROR_CLOSE });
      }, 2000);
    }
  }, [onBoardError, dispatch]);

  return (
    <>
      {loader && <Spinner />}

      <Alert show={onBoardError} message={obBoardErrorReason} />
      <div className="sisp-container">
        <Container />
      </div>
    </>
  );
}

export default App;
